<template>
	<article>
		<section class="xbed-sub-title">
			<span>订单统计报表</span>
		</section>

		<section class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>报表</BreadcrumbItem>
				<BreadcrumbItem>订单统计报表</BreadcrumbItem>
			</Breadcrumb>
		</section>

		<Tabs class="tabs add-distance" @on-click="toggleTab" style="margin-top:20px">
			<TabPane label="订单报表" name="orderList" ref="orderList">
				<Form :model="orderReportForm" inline>
					<Row>
						<FormItem label="创建日期：" prop="createTime" :label-width="80">
							<DatePicker v-model="orderReportForm.createTime" @on-change="dateRange => {changeDate(dateRange, 'orderReportForm', 'createTime')}" format="yyyy-MM-dd" type="daterange" :clearable="false" placeholder="选择日期" style="width: 200px"></DatePicker>
						</FormItem>
						<FormItem label="订单号：" prop="orderNo" :label-width="80">
							<Input type="text" v-model="orderReportForm.orderNo"></Input>
						</FormItem>
						<FormItem label="渠道单号：" prop="otaNo" :label-width="80">
							<Input type="text" v-model="orderReportForm.otaNo"></Input>
						</FormItem>
						<FormItem label="来源渠道：" prop="orderSource" :label-width="80">
							<Select v-model="orderReportForm.orderSource" filterable>
								<Option value="S00">全部</Option>
								<Option v-for="(orderSource, index) in sourceType" :key="index" :value="orderSource.id">{{orderSource.name}}</Option>
							</Select>
						</FormItem>
					</Row>
					<Row>
						<FormItem label="订单进度：" prop="status" :label-width="80">
							<Select v-model="orderReportForm.status" filterable>
								<Option value="S00">全部</Option>
								<Option :value="1">未开始</Option>
								<Option :value="2">进行中</Option>
								<Option :value="3">已结束</Option>
								<Option :value="4">取消</Option>
							</Select>
						</FormItem>
						<FormItem label="预订人：" prop="name" :label-width="80">
							<Input type="text" v-model="orderReportForm.name"></Input>
						</FormItem>
						<FormItem label="手机号：" prop="phone" :label-width="80">
							<Input type="text" v-model="orderReportForm.phone"></Input>
						</FormItem>
						<FormItem prop="export">
							<Button type="primary" @click="exportOrderData">导出</Button>
						</FormItem>
						<FormItem prop="query">
							<Button type="primary" @click="queryListOrderReport">查询</Button>
						</FormItem>
					</Row>
				</Form>
				<Table stripe :loading="orderList.loading" ref="orderReportTable" :columns="columns.order" :data="orderList.data"></Table>
				<div style="float: left;margin: 10px;overflow: hidden">
					<Page show-sizer placement="top" :total="orderList.count" :current="orderList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
				</div>
			</TabPane>
			<TabPane label="子入住单报表" name="subOrderList" ref="subOrderList">
				<Form :model="subOrderReportForm" inline>
					<Row>
						<FormItem label="创建日期：" prop="createTime" :label-width="80">
							<DatePicker v-model="subOrderReportForm.createTime" @on-change="dateRange => {changeDate(dateRange, 'subOrderReportForm', 'createTime')}" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
						</FormItem>
						<FormItem label="开始日期：" prop="beginTime" :label-width="80">
							<DatePicker v-model="subOrderReportForm.beginTime" @on-change="dateRange => {changeDate(dateRange, 'subOrderReportForm', 'beginTime')}" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
						</FormItem>
						<FormItem label="结束日期：" prop="endTime" :label-width="80">
							<DatePicker v-model="subOrderReportForm.endTime" @on-change="dateRange => {changeDate(dateRange, 'subOrderReportForm', 'endTime')}" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
						</FormItem>
					</Row>
					<Row>
						<FormItem label="订单号：" prop="orderNo" :label-width="80">
							<Input type="text" v-model="subOrderReportForm.orderNo"></Input>
						</FormItem>
						<FormItem label="OTA单号：" prop="otaNo" :label-width="80">
							<Input type="text" v-model="subOrderReportForm.otaNo"></Input>
						</FormItem>
						<FormItem label="预订手机：" prop="phone" :label-width="80">
							<Input type="text" v-model="subOrderReportForm.phone"></Input>
						</FormItem>
					</Row>
					<Row>
						<FormItem label="预订渠道：" prop="orderSource" :label-width="80">
							<Select v-model="subOrderReportForm.orderSource" filterable>
								<Option value="S00">全部</Option>
								<Option v-for="(orderSource, index) in sourceType" :key="index" :value="orderSource.id">{{orderSource.name}}</Option>
							</Select>
						</FormItem>
						<FormItem label="对账状态：" prop="accountState" :label-width="80">
							<Select v-model="subOrderReportForm.accountState" filterable>
								<Option value="S00">全部</Option>
								<Option :value="1">已对账</Option>
								<Option :value="2">未对账</Option>
							</Select>
						</FormItem>
						<FormItem label="收款状态：" prop="receiptState" :label-width="80">
							<Select v-model="subOrderReportForm.receiptState" filterable>
								<Option value="S00">全部</Option>
								<Option :value="1">已收款</Option>
								<Option :value="2">未收款</Option>
							</Select>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="queryListCheckinInfoReport">查询</Button>
						</FormItem>
						<FormItem style="margin-left: 80px;">
							<Button type="primary" @click="exportCheckinInfoReport" :loading="exportBtn">导出筛选结果</Button>
						</FormItem>
					</Row>
				</Form>
				<Table stripe :loading="subOrderList.loading" ref="orderReportTable" :columns="columns.subOrder" :data="subOrderList.data"></Table>
				<div style="float: left;margin: 10px;overflow: hidden">
					<Page show-sizer placement="top" :total="subOrderList.count" :current="subOrderList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
				</div>
			</TabPane>
		</Tabs>

		<Modal v-model="detailModalDisplay" ref="detailModal" :width="1000" title="状态 / 明细">
			<Row>
				<Col span="4" class-name="text-align-right">房间：</Col>
				<Col span="8">{{detailModal.baseInfo.room}}</Col>
				<Col span="4" class-name="text-align-right">性质：</Col>
				<Col span="8">{{detailModal.baseInfo.checkinInfoType}}</Col>
			</Row>
			<Row class-name="add-distance">
				<Col span="4" class-name="text-align-right">开始时间：</Col>
				<Col span="8">{{detailModal.baseInfo.beginTime}}</Col>
				<Col span="4" class-name="text-align-right">结束时间：</Col>
				<Col span="8">{{detailModal.baseInfo.endTime}}</Col>
			</Row>
			<Row class-name="add-distance">
				<Col span="4" class-name="text-align-right">进度状态：</Col>
				<Col span="8">{{detailModal.baseInfo.step}}</Col>
				<Col span="4" class-name="text-align-right">取消时间：</Col>
				<Col span="8">{{detailModal.baseInfo.cancelTime}}</Col>
			</Row>
			<Row type="flex" justify="center" align="middle" class-name="add-distance">
				<Col span="4" class-name="text-align-right">对账状态：</Col>
				<Col span="8">
					<Row type="flex" justify="start" align="middle">
						<Col>{{detailModal.baseInfo.accountState}}</Col>
						<Col v-show="detailModal.baseInfo.accountState=='未对账'" style="margin-left: 20px;">
							<Button type="primary" size="small" @click="openEditStateModal('account')">修改</Button>
						</Col>
					</Row>
				</Col>
				<Col span="4" class-name="text-align-right">收款状态：</Col>
				<Col span="8">
					<Row type="flex" justify="start" align="middle">
						<Col>{{detailModal.baseInfo.receiptState}}</Col>
						<Col v-show="detailModal.baseInfo.receiptState=='未收款'" style="margin-left: 20px;">
							<Button type="primary" size="small" @click="openEditStateModal('receipt')">修改</Button>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row class-name="add-distance">
				<Col span="4" class-name="text-align-right">备注：</Col>
				<Col span="20">
					<p v-for="(remark, index) in detailModal.baseInfo.remark" :key="index">{{remark}}</p>
				</Col>
			</Row>
			<Row class-name="add-distance">
				<Table stripe :loading="detailModal.loading" ref="detailTable" :columns="detailColumn" :data="detailModal.data"></Table>
			</Row>
			<section slot="footer"></section>
		</Modal>
		<Modal v-model="editStatusModalDisplay" ref="editStateModal" :loading="true" :width="500" :title="editStateModalForm.title" ok-text="提交" @on-ok="prepareEditState" @on-cancel="cancelEditState">
			<Form v-model="editStateModalForm">
				<FormItem label="状态：" prop="modalKeyWord" :label-width="50">
					<Select v-if="editStateModalForm.type==1" key="account" v-model="editStateModalForm.state">
						<Option :value="1">未对账</Option>
						<Option :value="2">已对账</Option>
					</Select>
					<Select v-if="editStateModalForm.type==2" key="receipt" v-model="editStateModalForm.state">
						<Option :value="1">未收款</Option>
						<Option :value="2">已收款</Option>
					</Select>
				</FormItem>
				<FormItem label="备注：" prop="modalKeyWord" :label-width="50">
					<Input type="textarea" v-model="editStateModalForm.remark" placeholder="必填"></Input>
				</FormItem>
			</Form>
		</Modal>

	</article>
</template>

<script>
import Moment from "moment";
import Config from "../../config"
import Utils from "../../utils";
import API from "../../api";
import {STORE_KEY} from "../../constants"

export default {
	async created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	async mounted() {
		this.$Notice.config( {
			top: 200
		} );
		let sourceTypeResp = ( await API.omsAPI[this.env].php.queryOrderSource() ).data
		if ( sourceTypeResp.retCode ) {
			this.$Notice.error( {
				title: "获取渠道失败",
				desc: sourceTypeResp.msg
			} );
		}
		this.sourceType = sourceTypeResp.retdata;

		this.listOrderReport();
	},
	data() {
		let beforeDate = new Date();
		beforeDate.setDate( beforeDate.getDate() - 14 );
		let defaultDate = [
			Moment().subtract( 14, 'days' ).format( 'YYYY-MM-DD' ),
			Moment().format( 'YYYY-MM-DD' )
		];
		return {
			exportBtn: false,
			currTabName: "orderList",
			sourceType: [],
			orderList: {
				tabName: "orderList",
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			},
			subOrderList: {
				tabName: "subOrderList",
				count: 0,
				pageCount: 0,
				page: 1,
				pageSize: 10,
				loading: false,
				data: []
			},
			columns: {
				order: [
					{
						title: "订单号",
						key: "orderNo",
						align: "center",
						width: 200
					},
					{
						title: "创建时间",
						key: "createdAt",
						align: "center",
						width: 200,
						render: ( h, params ) => {
							let createdAt = Moment( params.row.createdAt ).format( 'YYYY-MM-DD HH:mm:ss' );
							return h( "div", {}, createdAt );
						}
					},
					{
						title: "来源渠道",
						key: "source",
						width: 200,
						align: "center"
					},
					{
						title: "渠道单号",
						key: "otherNo",
						width: 300,
						align: "center"
					},
					{
						title: "预订人",
						key: "booker",
						width: 300,
						align: "center"
					},
					{
						title: "订单房晚数",
						key: "roomDays",
						width: 200,
						align: "center"
					},
					{
						title: "推广信息",
						key: "promotionInfo",
						width: 200,
						align: "center"
					},
					{
						title: "订单进度",
						key: "status",
						width: 200,
						align: "center"
					},
					{
						title: "订单原价",
						key: "orderPrice",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let orderPrice = ( params.row.orderPrice / 100 ).toFixed( 2 );
							return h( "div", {}, orderPrice );
						}
					},
					{
						title: "优惠",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							const discount = ( params.row.discount / 100 ).toFixed( 2 );
							return h( "div", {}, discount );
						}
					},
					{
						title: "应收",
						key: "realPrice",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let realPrice = ( params.row.realPrice / 100 ).toFixed( 2 );
							return h( "div", {}, realPrice );
						}
					},
					{
						title: "渠道费",
						key: "channelPrice",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let channelPrice = ( params.row.channelPrice / 100 ).toFixed( 2 );
							return h( "div", {}, channelPrice );
						}
					},
					{
						title: "Xdollar",
						key: "xdollar",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let xdollar = ( params.row.xdollar / 100 ).toFixed( 2 );
							return h( "div", {}, xdollar );
						}
					},
					{
						title: "实收",
						key: "receivedPrice",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let receivedPrice = ( params.row.receivedPrice / 100 ).toFixed( 2 );
							return h( "div", {}, receivedPrice );
						}
					},
					{
						title: "实收房费",
						key: "roomPrice",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let roomPrice = ( params.row.roomPrice / 100 ).toFixed( 2 );
							return h( "div", {}, roomPrice );
						}
					},
					{
						title: "实收增值服务",
						key: "serviceFee",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let serviceFee = ( params.row.serviceFee / 100 ).toFixed( 2 );
							return h( "div", {}, serviceFee );
						}
					},
					{
						title: "实收押金",
						key: "bargainMoney",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let bargainMoney = ( params.row.bargainMoney / 100 ).toFixed( 2 );
							return h( "div", {}, bargainMoney );
						}
					}
				],
				subOrder: [
					{
						title: "订单号",
						key: "orderNo",
						width: 200,
						align: "center"
					},
					{
						title: "子入住单号",
						key: "checkinInfoId",
						width: 200,
						align: "center"
					},
					{
						title: "创建时间",
						key: "createTime",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let createTime = Moment( params.row.createTime ).format( 'YYYY-MM-DD HH:mm:ss' );
							return h( "div", {}, createTime );
						}
					},
					{
						title: "预定渠道",
						key: "orderSourceName",
						width: 200,
						align: "center"
					},
					{
						title: "渠道单号",
						key: "otaNo",
						width: 200,
						align: "center"
					},
					{
						title: "预订人",
						key: "booker",
						width: 200,
						align: "center"
					},
					{
						title: "房间",
						key: "room",
						width: 200,
						align: "center"
					},
					{
						title: "进行时间",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let beginTime = Moment( params.row.beginTime ).format( 'YYYY-MM-DD HH:mm:ss' );
							let endTime = Moment( params.row.endTime ).format( 'YYYY-MM-DD HH:mm:ss' );
							return h(
								"div",
								[
									h( "div", {}, `开始：${ beginTime }` ),
									h( "div", {}, `结束：${ endTime }` )
								],
								""
							);
						}
					},
					{
						title: "进度",
						key: "step",
						width: 200,
						align: "center"
					},
					{
						title: "房费原价",
						key: "roomPrice",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let roomPrice = params.row.roomPrice !== null ? params.row.roomPrice : 0
							roomPrice = ( roomPrice / 100 ).toFixed( 2 );
							return h( "div", {}, roomPrice );
						}
					},
					{
						title: "优惠扣减",
						key: "discount",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let discount = params.row.discount !== null ? params.row.discount : 0
							discount = ( discount / 100 ).toFixed( 2 );
							return h( "div", {}, discount );
						}
					},
					{
						title: "房费应收",
						key: "realPrice",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let realPrice = params.row.realPrice !== null ? params.row.realPrice : 0
							realPrice = ( realPrice / 100 ).toFixed( 2 );
							return h( "div", {}, realPrice );
						}
					},
					{
						title: "渠道费",
						key: "channelPrice",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let channelPrice = params.row.channelPrice !== null ? params.row.channelPrice : 0
							channelPrice = ( channelPrice / 100 ).toFixed( 2 );
							return h( "div", {}, channelPrice );
						}
					},
					{
						title: "Xdollar",
						key: "Xdollar",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let Xdollar = params.row.Xdollar !== null ? params.row.Xdollar : 0
							Xdollar = ( Xdollar / 100 ).toFixed( 2 );
							return h( "div", {}, Xdollar );
						}
					},
					{
						title: "实收房费",
						key: "receivedPrice",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let receivedPrice = params.row.receivedPrice !== null ? params.row.receivedPrice : 0
							receivedPrice = ( receivedPrice / 100 ).toFixed( 2 );
							return h( "div", {}, receivedPrice );
						}
					},
					{
						title: "对账状态",
						key: "accountState",
						width: 200,
						align: "center"
					},
					{
						title: "收款状态",
						key: "receiptState",
						width: 200,
						align: "center"
					},
					{
						title: "操作",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							return h( "div", [
								h(
									"Button",
									{
										props: {
											type: "primary",
											size: "small"
										},
										style: {
											marginRight: "10px"
										},
										on: {
											click: () => {
												this.openDetailModal( params.row.id );
											}
										}
									},
									"状态/明细"
								)
							] );
						}
					}
				]
			},
			detailColumn: [
				{
					title: "支付单号",
					key: "payNo",
					align: "center",
					width: 200
				},
				{
					title: "结算单号",
					key: "settlementNo",
					align: "center",
					width: 200
				},
				{
					title: "支付方式",
					key: "payTypeName",
					width: 200,
					align: "center"
				},
				{
					title: "子单实收金额",
					key: "receivedPrice",
					width: 300,
					align: "center",
					render: ( h, params ) => {
						let receivedPrice = params.row.receivedPrice !== null ? params.row.receivedPrice : 0
						receivedPrice = ( receivedPrice / 100 ).toFixed( 2 );
						return h( "div", {}, receivedPrice );
					}
				},
				// {
				//   title: "子单退款金额",
				//   key: "refundPrice",
				//   width: 300,
				//   align: "center",
				//   render: (h, params) => {
				//     let refundPrice = params.row.refundPrice !== null ? params.row.refundPrice : 0
				//     refundPrice = (refundPrice / 100).toFixed(2);
				//     return h("div", {}, refundPrice);
				//   }
				// },
				{
					title: "对账状态",
					key: "accountState",
					width: 200,
					align: "center"
				},
				{
					title: "收款状态",
					key: "receiptState",
					width: 200,
					align: "center"
				},
				{
					title: "导出时间",
					width: 200,
					align: "center",
					render: ( h, params ) => {
						let accountTime = params.row.accountTime !== null ? Moment( params.row.accountTime ).format( 'YYYY-MM-DD HH:mm:ss' ) : "";
						let receiptTime = params.row.receiptTime !== null ? Moment( params.row.receiptTime ).format( 'YYYY-MM-DD HH:mm:ss' ) : "";
						return h(
							"div",
							[
								h( "div", {}, `对账：${ accountTime }` ),
								h( "div", {}, `收款：${ receiptTime }` )
							],
							""
						);
					}
				}
			],
			orderReportForm: {
				createTime: defaultDate,
				orderNo: "",
				otaNo: "",
				orderSource: "S00",
				status: "S00",
				name: "",
				phone: ""
			},
			subOrderReportForm: {
				createTime: defaultDate,
				beginTime: [],
				endTime: [],
				orderNo: "",
				otaNo: "",
				phone: "",
				orderSource: "S00",
				accountState: "S00",
				receiptState: "S00"
			},
			detailModal: {
				loading: false,
				baseInfo: {
					accountState: "",
					beginTime: "",
					cancelTime: "",
					checkinInfoType: "",
					endTime: "",
					receiptState: "",
					remark: "",
					room: "",
					step: ""
				},
				data: []
			},
			detailModalDisplay: false,
			editStateModalForm: {
				title: "",
				action: "",
				id: 0,
				type: 1,
				state: 1,
				remark: ""
			},
			editStatusModalDisplay: false
		};
	},
	methods: {
		changeDate( dateRange, formName, datePicker ) {
			if ( !dateRange[0] ) {
				this[formName][datePicker] = [];
			} else {
				let tranferDate = []
				for ( let i = 0; i < dateRange.length; i++ ) {
					let date = Moment( dateRange[i] ).format( 'YYYY-MM-DD' )
					tranferDate.push( date );
				}
				this[formName][datePicker] = tranferDate;
			}
		},
		toggleTab( tabName ) {
			this.currTabName = tabName;
			this[tabName].page = 1;
			this.queryOrderReport();
		},
		changePage( pageIndex ) {
			this[this.currTabName].page = pageIndex;
			this.queryOrderReport();
		},
		changePageSize( pageSize ) {
			this[this.currTabName].page = 1;
			this[this.currTabName].pageSize = pageSize;
			this.queryOrderReport();
		},
		queryOrderReport() {
			if ( this.currTabName == "orderList" ) {
				this.listOrderReport()
			} else if ( this.currTabName == "subOrderList" ) {
				this.listCheckinInfoReport()
			}
		},
		// 订单报表
		queryListOrderReport() {
			if ( !this.checkOrderAccess() ) {
				return;
			}
			this.orderList.page = 1;
			this.listOrderReport();
		},
		async listOrderReport() {
			this.orderList.loading = true;
			let resp = ( await this.sendListOrderReport( this.orderList, this.token, this.env ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
			}
			this.orderList.data = resp.result;
			this.orderList.count = resp.count;
			this.orderList.pageCount = resp.pageCount;
			this.orderList.loading = false;
		},
		sendListOrderReport( orderList, token, env ) {
			let params = {
				page: orderList.page,
				size: orderList.pageSize,
				startDate: Moment( this.orderReportForm.createTime[0] ).format( 'YYYY-MM-DD' ),
				endDate: Moment( this.orderReportForm.createTime[1] ).format( 'YYYY-MM-DD' ),
			};
			this.orderReportForm.name ? params.name = this.orderReportForm.name : '';
			this.orderReportForm.orderNo ? params.orderNo = this.orderReportForm.orderNo : '';
			this.orderReportForm.orderSource !== "S00" ? params.source = this.orderReportForm.orderSource : '';
			this.orderReportForm.otaNo ? params.otherNo = this.orderReportForm.otaNo : '';
			this.orderReportForm.phone ? params.phone = this.orderReportForm.phone : '';
			this.orderReportForm.status !== "S00" ? params.status = this.orderReportForm.status : '';
			return API.omsAPI[env].order.queryOrderReport( params, token );
		},
		checkOrderAccess() {
			if ( this.orderReportForm.createTime.join( '' ).length == 0 ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: "创建日期不能为空"
				} );
				return false;
			}
			return true;
		},
		// 子入住单报表
		queryListCheckinInfoReport() {
			if ( !this.checkSubOrderAccess() ) {
				return;
			}
			this.subOrderList.page = 1;
			this.listCheckinInfoReport();
		},
		async listCheckinInfoReport() {
			this.subOrderList.loading = true;
			let resp = ( await this.sendListCheckinInfoReport( this.subOrderList, this.token, this.env ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
			}
			this.subOrderList.data = resp.result;
			this.subOrderList.count = resp.count;
			this.subOrderList.pageCount = resp.pageCount;
			this.subOrderList.loading = false;
		},
		sendListCheckinInfoReport( subOrderList, token, env ) {
			let params = {
				page: subOrderList.page,
				size: subOrderList.pageSize,
			};
			this.subOrderReportForm.accountState !== "S00" ? params.accountState = this.subOrderReportForm.accountState : '';
			if ( this.subOrderReportForm.createTime[1] ) {
				params.startDate = Moment( this.subOrderReportForm.createTime[0] ).format( 'YYYY-MM-DD' );
				params.endDate = Moment( this.subOrderReportForm.createTime[1] ).format( 'YYYY-MM-DD' );
			}
			if ( this.subOrderReportForm.beginTime[1] ) {
				params.beginCheckinTime = Moment( this.subOrderReportForm.beginTime[0] ).format( 'YYYY-MM-DD' );
				params.endCheckinTime = Moment( this.subOrderReportForm.beginTime[1] ).format( 'YYYY-MM-DD' );
			}
			if ( this.subOrderReportForm.endTime[1] ) {
				params.beginCheckoutTime = Moment( this.subOrderReportForm.endTime[0] ).format( 'YYYY-MM-DD' );
				params.endCheckoutTime = Moment( this.subOrderReportForm.endTime[1] ).format( 'YYYY-MM-DD' );
			}
			this.subOrderReportForm.orderNo ? params.orderNo = this.subOrderReportForm.orderNo : '';
			this.subOrderReportForm.orderSource !== "S00" ? params.orderSource = this.subOrderReportForm.orderSource : '';
			this.subOrderReportForm.otaNo ? params.otaNo = this.subOrderReportForm.otaNo : '';
			this.subOrderReportForm.phone ? params.phone = this.subOrderReportForm.phone : '';
			this.subOrderReportForm.receiptState !== "S00" ? params.receiptState = this.subOrderReportForm.receiptState : '';

			return API.omsAPI[env].order.queryListCheckinInfoReport( params, token );
		},
		checkSubOrderAccess() {
			if (
				this.subOrderReportForm.createTime.join( '' ).length == 0 &&
				this.subOrderReportForm.beginTime.join( '' ).length == 0 &&
				this.subOrderReportForm.endTime.join( '' ).length == 0
			) {
				this.$Notice.error( {
					title: "查询失败",
					desc: "创建日期、开始日期、结束日期至少一项不能为空"
				} );
				return false;
			}
			return true;
		},
		// 状态/明细 modal
		openDetailModal( id ) {
			this.queryListCheckinInfoDetailInfo( id );
			this.detailModalDisplay = true;
		},
		async queryListCheckinInfoDetailInfo( id ) {
			let resp = ( await API.omsAPI[this.env].order.queryListCheckinInfoDetailInfo( id, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取渠道失败",
					desc: resp.msg
				} );
			}
			this.detailModal.baseInfo = resp.baseInfo;
			this.formatTime();
			this.detailModal.data = resp.payInfo;
		},
		formatTime() {
			if ( this.detailModal.baseInfo.beginTime !== null ) {
				this.detailModal.baseInfo.beginTime = Moment( this.detailModal.baseInfo.beginTime ).format( 'YYYY-MM-DD HH:mm:ss' );
			}
			if ( this.detailModal.baseInfo.endTime !== null ) {
				this.detailModal.baseInfo.endTime = Moment( this.detailModal.baseInfo.endTime ).format( 'YYYY-MM-DD HH:mm:ss' );
			}
			if ( this.detailModal.baseInfo.cancelTime !== null ) {
				this.detailModal.baseInfo.cancelTime = Moment( this.detailModal.baseInfo.cancelTime ).format( 'YYYY-MM-DD HH:mm:ss' );
			}
		},
		// 修改对账/收款单 modal
		openEditStateModal( action ) {
			if ( !this.checkHasPermission( 'oms_analysis_check_updateCheckinInfoCheckState' ) ) {
				return;
			}
			if ( action === "account" ) {
				this.editStateModalForm.title = "修改对账状态";
				this.editStateModalForm.type = 1;
			} else if ( action === "receipt" ) {
				this.editStateModalForm.title = "修改收款状态";
				this.editStateModalForm.type = 2;
			}
			this.editStateModalForm.id = this.detailModal.baseInfo.id;
			this.editStatusModalDisplay = true;
		},
		async prepareEditState() {
			if ( this.editStateModalForm.remark.length == 0 ) {
				this.$Notice.error( {
					title: "修改失败",
					desc: "备注不能为空"
				} );
				this.$refs.editStateModal.buttonLoading = false;
				return;
			}
			let resp = ( await this.sendUpdateCheckinInfoCheckState() ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "修改状态失败",
					desc: resp.msg
				} );
				this.$refs.editStateModal.buttonLoading = false;
			} else {
				this.$Notice.success( {
					title: "修改状态成功"
				} );
				this.queryListCheckinInfoDetailInfo( this.detailModal.baseInfo.id );

				this.resetEditStateModalForm();
				this.editStatusModalDisplay = false;
			}
		},
		sendUpdateCheckinInfoCheckState() {
			return API.omsAPI[this.env].order.updateCheckinInfoCheckState(
				this.editStateModalForm.id,
				this.username,
				this.editStateModalForm.remark,
				this.editStateModalForm.state,
				this.editStateModalForm.type,
				this.token );
		},
		cancelEditState() {
			this.resetEditStateModalForm();
		},
		resetEditStateModalForm() {
			this.editStateModalForm = {
				title: "",
				action: "",
				id: 0,
				type: 1,
				state: 1,
				remark: ""
			};
		},
		exportOrderData() {
			if ( !this.checkHasPermission( 'excel_exportOrderReport' ) ) {
				return;
			}
			if ( this.orderReportForm.createTime.join( '' ).length == 0 ) {
				this.$Notice.error( {
					title: "导出失败",
					desc: "创建日期不能为空"
				} );
				this.$refs.editStateModal.buttonLoading = false;
				return;
			}
			let jsonData = {
				page: this.orderList.page,
				size: this.orderList.pageSize,
				startDate: Moment( this.orderReportForm.createTime[0] ).format( 'YYYY-MM-DD' ),
				endDate: Moment( this.orderReportForm.createTime[1] ).format( 'YYYY-MM-DD' ),
				orderNo: this.orderReportForm.otherNo || '',
				otherNo: this.orderReportForm.otaNo || '',
				name: this.orderReportForm.name || '',
				phone: this.orderReportForm.phone || '',
				status: this.orderReportForm.status !== "S00" ? this.orderReportForm.status : '',
				orderSource: this.orderReportForm.orderSource !== "S00" ? this.orderReportForm.orderSource : ''
			}
			const exportUrl = `${ Config[this.env].phpUrl }Interface/index.php/Home/Reserve/exportOrderReport?json_data=${ JSON.stringify( jsonData ) }`

			Utils.exportExcelWeighting( exportUrl, this.token, this.$Notice.error, this, "" )
		},
		// 导出筛选结果
		exportCheckinInfoReport() {
			if ( !this.checkHasPermission( 'check_exportCheckinInfoReport' ) ) {
				return;
			}
			if ( this.subOrderReportForm.createTime.join( '' ).length == 0 ) {
				this.$Notice.error( {
					title: "导出失败",
					desc: "创建日期不能为空"
				} );
				return;
			}
			let url = `${ Config[this.env].analysisUrl }check/exportCheckinInfoReport` +
				"?startDate=" + Moment( this.subOrderReportForm.createTime[0] ).format( 'YYYY-MM-DD' ) +
				"&endDate=" + Moment( this.subOrderReportForm.createTime[1] ).format( 'YYYY-MM-DD' ) +
				"&beginCheckinTime=" + ( this.subOrderReportForm.beginTime.join( '' ).length == 0 ? '' : Moment( this.subOrderReportForm.beginTime[0] ).format( 'YYYY-MM-DD' ) ) +
				"&endCheckinTime=" + ( this.subOrderReportForm.beginTime.join( '' ).length == 0 ? '' : Moment( this.subOrderReportForm.beginTime[1] ).format( 'YYYY-MM-DD' ) ) +
				"&beginCheckoutTime=" + ( this.subOrderReportForm.endTime.join( '' ).length == 0 ? '' : Moment( this.subOrderReportForm.endTime[0] ).format( 'YYYY-MM-DD' ) ) +
				"&endCheckoutTime=" + ( this.subOrderReportForm.endTime.join( '' ).length == 0 ? '' : Moment( this.subOrderReportForm.endTime[1] ).format( 'YYYY-MM-DD' ) ) +
				"&orderNo=" + this.subOrderReportForm.orderNo +
				"&orderSource=" + ( this.subOrderReportForm.orderSource == "S00" ? '' : this.subOrderReportForm.orderSource ) +
				"&otaNo=" + this.subOrderReportForm.otaNo +
				"&phone=" + this.subOrderReportForm.phone +
				"&receiptState=" + ( this.subOrderReportForm.receiptState == "S00" ? '' : this.subOrderReportForm.receiptState );

			// window.open(url ,"_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )
		},
		checkHasPermission( name ) {
			if ( !Utils.hasPermission( name ) ) {
				this.$Notice.error( {
					title: Utils.getFromStore( STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS )
				} );

				return false;
			}
			return true;
		},
		resetTabPane() {
			this.orderList = {
				tabName: "orderList",
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			};
			this.subOrderList = {
				tabName: "subOrderList",
				count: 0,
				pageCount: 0,
				page: 1,
				pageSize: 10,
				loading: false,
				data: []
			}
		},
		refreshTable() {
			this.resetTabPane();
			this.queryOrderReport();
		}
	}
};
</script>

<style lang="scss" scoped>
.add-wrapper {
	margin-top: 20px;
}

.tabs {
	margin-top: 20px;
}

.table-wrapper {
	margin-top: 20px;
}

.add-distance {
	margin-top: 10px;
}

.text-align-right {
	text-align: right;
}

.text-align-center {
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/report/order-report.vue